import { Grid } from "@mui/material";
import { Works } from "./works/Works";
import { PkCommonHeader } from "../../components/common/PkCommonHeader";
import { PkCommonFooter } from "../../components/common/PkCommonFooter";
export function TermsPage() {
  return (
    <Grid container sx={{ width: "100%" }}>
      <Grid xs={12} item>
        <PkCommonHeader />
      </Grid>
      <Grid className="page__terms" xs={12} item>
        <Works />
      </Grid>
      <Grid xs={12} item>
        <PkCommonFooter />
      </Grid>
    </Grid>
  );
}
